import React from 'react';
import PropTypes from 'prop-types';
import styles from './PageHeader.module.css';

const capitalizeFirst = (str) => {
  if (!str || typeof str !== 'string') return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const PageHeader = ({
  title,
  subtitle,
  actions,
  breadcrumbs,
  icon,
  logo,
  className = '',
  divider = true,
  ...rest
}) => {
  const containerClasses = [styles.container, className].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} {...rest}>
      <div className={styles.headerContent}>
        <div className={styles.content}>
          {breadcrumbs && breadcrumbs.length > 0 && (
            <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
              {breadcrumbs.map((crumb, index) => {
                const isLast = index === breadcrumbs.length - 1;
                const isReactElement = React.isValidElement(crumb);
                
                return (
                  <React.Fragment key={index}>
                    {index > 0 && (
                      <span className={styles.separator} aria-hidden="true">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6 3L10 8L6 13"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    )}
                    {isReactElement ? (
                      crumb
                    ) : (
                      <span className={isLast ? styles.currentCrumb : styles.crumb}>
                        {typeof crumb === 'string' ? capitalizeFirst(crumb) : crumb}
                      </span>
                    )}
                  </React.Fragment>
                );
              })}
            </nav>
          )}
          <div className={styles.titleSection}>
            <h1 className={styles.title}>
              {logo && <span className={styles.logoWrapper}>{logo}</span>}
              {!logo && icon && <span className={styles.icon}>{icon}</span>}
              {title}
            </h1>
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          </div>
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {
        divider && <div className={styles.divider} />
      }

    </div>
  );
};

PageHeader.propTypes = {
  // The component renders both through, and callers legitimately pass elements:
  // DetailsClients builds clickable <span> breadcrumbs, and its title comes from
  // formatClientNameWithId(), which returns JSX. The body already branches on
  // React.isValidElement(crumb); only these declarations were out of date, and
  // they logged a PropTypes warning on every render of those screens.
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  actions: PropTypes.node,
  breadcrumbs: PropTypes.arrayOf(PropTypes.node),
  icon: PropTypes.node,
  logo: PropTypes.node,
  className: PropTypes.string,
};

export default PageHeader;
